import basicTheme from '../basicTheme.js';

const radioStyleOverrides = {
    defaultProps: {
        blurOnSelect: true,
        clearOnBlur: true,
        handleHomeEndKeys: true,
    },
    styleOverrides: {
        paper: {
            margin: basicTheme.spacing(0.75, 0, 0, 0),
            borderRadius: '4px',
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))',
            backgroundColor: basicTheme.palette.N40.main,
        },
        option: Object.assign(Object.assign({ display: 'flex', alignItems: 'center', height: '20px', color: basicTheme.palette.N20.main, backgroundColor: 'transparent', transition: `opacity ${basicTheme.transitions.duration.fast} linear, color ${basicTheme.transitions.duration.fast} linear, background-color ${basicTheme.transitions.duration.fast} linear, stroke ${basicTheme.transitions.duration.fast} linear` }, basicTheme.typography.body1), { '&:hover': {
                color: basicTheme.palette.N05.main,
                backgroundColor: basicTheme.palette.N30.main,
                path: {
                    stroke: basicTheme.palette.N05.main,
                },
            } }),
        listbox: {
            padding: basicTheme.spacing(1, 0),
            overflow: 'overlay',
            maxHeight: '225px',
            '.MuiAutocomplete-option.Mui-focused': {
                color: basicTheme.palette.N05.main,
                backgroundColor: basicTheme.palette.N30.main,
                path: {
                    stroke: basicTheme.palette.N05.main,
                },
            },
            '.MuiAutocomplete-option[aria-selected="true"]': {
                backgroundColor: 'transparent',
                '&.Mui-focused': {
                    backgroundColor: 'transparent',
                    color: basicTheme.palette.N20.main,
                    path: {
                        stroke: basicTheme.palette.N20.main,
                    },
                },
                '&:hover': {
                    color: basicTheme.palette.N05.main,
                    backgroundColor: basicTheme.palette.N30.main,
                    path: {
                        stroke: basicTheme.palette.N05.main,
                    },
                },
            },
            '.MuiAutocomplete-option[aria-disabled="true"]': {
                opacity: 0.4,
                pointerEvents: 'auto',
                cursor: 'not-allowed',
                backgroundColor: 'transparent',
                color: basicTheme.palette.N20.main,
                '&:hover': {
                    color: basicTheme.palette.N20.main,
                    backgroundColor: 'transparent !important',
                },
            },
        },
        // @ts-ignore
        noOptions: Object.assign(Object.assign({}, basicTheme.typography.body4), { color: basicTheme.palette.N30.main, padding: basicTheme.spacing(1.5, 0.5, 1.5, 3), opacity: '0.4' }),
    },
};

export { radioStyleOverrides as default };
//# sourceMappingURL=MuiAutocomplete.js.map
